module.exports = __webpack_public_path__ + "img/LUB00375.7555398b.png";